VP = window.VP || {};

(function( $ ) {
	VP.allPressReleases = {

		maxItemsPerPage: 12,

		selectors: {
			module: 'vp-all-press-release',
			filter: 'vp-all-press-release__category',
			itemsWrapper: 'vp-all-press-release__items',
			loadMore: 'vp-all-press-release__load-more',
			btnBusy: 'vp-btn--busy',
		},

		init: function () {
			var _this = this;
			_this.eventHandler();

			// Empty the search box
			$( '.vp-textbox', $( '.' + _this.selectors.module ) ).val('');
		},

		eventHandler: function() {
			var _this = this;

			// Filter event handler
			$('.' + _this.selectors.filter).change(function(e) {
				$el = $(this);
				_this.filter($el.val());
			});

			// Load more event handler
			$('.' + _this.selectors.loadMore).click(function(e) {
				e.preventDefault();
				_this.loadMore();
			});

			// Prevent the form from submitting when the search field is empty
			$( 'form', $( '.' + _this.selectors.module ) ).submit(function(e) {
				if( $.trim( $( '.vp-textbox', $( '.' + _this.selectors.module ) ).val() ) === '' ) {
					e.preventDefault();
				}
			});


			// if url contains ?filter=term, then change the selection filter
			 var filtered = VP.helpers.getQParams("filtered")

			 //console.log(filtered);
			if(filtered){
				// console.log("filtered");
				//$(".vp-all-press-release__category").val(filtered).change();
			}


		/*	EB */
		},

		filter: function(type) {
			var _this = this;

			VP.helpers.setQParams( {filtered:type} , {type:"replace"} );
			VP.helpers.setQParams( {cpage:""} , {type:"replace"} );	// reset paging on type change

			// Fire off the request to ajax.php
			VP.request.get(
				'filter_press_release',
				{
					type: type,
					filters: $('.' + _this.selectors.filter).data('filters'),
				},
				function ( response ) {
					// Update contents
					if( response !== '' ) {
						response = jQuery.parseJSON(response);
						$('.' + _this.selectors.itemsWrapper).html(response.html);
						$('.' + _this.selectors.itemsWrapper).data('page', 1);
					}

					// console.log("response.post_count: " + response.post_count);
					// console.log(_this.maxItemsPerPage );
					// Hide the load more button if there are no remaning contents to show
					if( response.post_count < _this.maxItemsPerPage ) {
						$('.' + _this.selectors.loadMore).hide();
					} else {
						$('.' + _this.selectors.loadMore).show();
					}
				},
				function ( error, xhr ) {
					console.error("Unable to load more content.");
				}
			);
		},

		loadMore: function() {
			var _this = this;
			var type = $('.' + _this.selectors.filter).val();
			var page = $('.' + _this.selectors.itemsWrapper).data('page');

			if ($('.' + _this.selectors.loadMore).hasClass(_this.selectors.btnBusy)) {
				return;
			}

			// Show loading state
			$('.' + _this.selectors.loadMore).addClass(_this.selectors.btnBusy);

			// Fire off the request to ajax.php
			VP.request.get(
				'filter_press_release',
				{
					type: type,
					page: page,
					filters: $('.' + _this.selectors.filter).data('filters'),
				},
				function ( response ) {
					// Update contents
					if( response !== '' ) {
						response = jQuery.parseJSON(response);
						$('.' + _this.selectors.itemsWrapper).append(response.html);
						$('.' + _this.selectors.itemsWrapper).data('page', page + 1);
						//VP.helpers.setQParams("cpage",  page + 1);
						VP.helpers.setQParams( {cpage:page + 1} , {type:"replace"} );

						//reset Reveal metrics since height of page has changed
						VP.reveal.updatePosition();
					}

					// Hide the load more button if there are no remaning contents to show
					if( response.post_count < _this.maxItemsPerPage ) {
						$('.' + _this.selectors.loadMore).hide();
					}

					$('.' + _this.selectors.loadMore).removeClass(_this.selectors.btnBusy);
				},
				function ( error, xhr ) {
					console.error("Unable to load more content.");
				}
			);
		},
	};
})(jQuery);

if( jQuery( '.' + VP.allPressReleases.selectors.module ).length > 0 ) {
	VP.allPressReleases.init();
}
